(function () {
    'use strict';
    var controllerId = 'gettyCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location', '$modal', '$routeParams','NgTableParams', gettyCtrl]);
    function gettyCtrl(common, datacontext, $scope, $location, $modal, $routeParams, NgTableParams) {
        //console.log('called');
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        vm.title = 'Getty List View';
        vm.downloading = 0;
        vm.searching = 0;
        vm.download_id = "";
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            search_by_id:0,
            order_by:'',
            order_dir:'desc',
            page:1,
            limit:30
        };

/*
        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                   // console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;

                    if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true ){
                        get_getty_images();
                    }else{
                        return "";
                    }
                }
            }
        });
*/

        $scope.filterGettyId = function(value) {
//        function filterGettyId(value) {
            //console.log('filter');
            //console.log(value);
            var list = vm.get_getty_id_list;
            //console.log(list);
            for (var i = 0; i < list.length; i++) {
                //console.log(list[i].getty_id);
                if(list[i].getty_id === value){
                   return false;
                }
                //console.log(item[key].getty_id);
            }
            return true;
        }

        activate();

        function activate() {
            var promises = [
                get_getty_images()
                //,
                //get_getty_id_list()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_getty_id_list(data) {
            return datacontext.get_getty_id_list({data:vm.getty_id_list}).then(function(httpResult) {
                vm.get_getty_id_list = httpResult.data.data;
            });
        }

        function get_getty_images(data,search_by_id) {

            vm.query.search = data;
            vm.query.search_by_id = search_by_id;

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    console.log(vm.query);
                    // ajax request to api
                    return datacontext.get_getty_images(vm.query).then(function (httpResult) {
                        //console.log(httpResult);
                        //console.log(httpResult.data.COUNT);
                        params.total(httpResult.data.COUNT);
                        vm.results_total = httpResult.data.COUNT;
                        vm.query.page = params.page;
                        // set new data
                        vm.get_getty_id_list = httpResult.data.DATA1.data;
                        vm.getty_id_list = httpResult.data.ID_LIST;
                        vm.results = httpResult.data.data;
                        //console.log(vm.results);
                        if(angular.isDefined(httpResult.data.COUNT)){
                            log_success(httpResult.data.COUNT+' Results Found');
                        }else{
                            log_error(httpResult.data.ERROR);
                        }
                        vm.searching = 0;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.search = function(data,search_by_id) {

            if(angular.isDefined(search_by_id) && search_by_id == 1 && !angular.isNumber(vm.query.search) && vm.query.search.length !== 9){
                log_error('Invalid Getty Id')
                return "";
            }

            vm.searching = 1;
            get_getty_images(data,search_by_id);
        };

        $scope.download = function(id,title,presell) {
           console.log(id+','+title+','+presell);
           vm.downloading = 1;
           vm.download_id = id;
           log_success('Downloading');
           return datacontext.download_getty_image({"id":id,"title":title,"presell":presell}).then(function (httpResult) {
               //console.log(httpResult);
               log_success(httpResult.data.data);
               vm.downloading = 0;
               get_getty_id_list({data:vm.getty_id_list});
               //get_getty_images();
               //$scope.$broadcast('refreshAuditLog', 'refresh');
           });
        };



    }
})();

(function () {
    'use strict';
    var controllerId = 'gettyReportCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location', '$modal', '$routeParams','NgTableParams', gettyReportCtrl]);
    function gettyReportCtrl(common, datacontext, $scope, $location, $modal, $routeParams, NgTableParams) {
        //console.log('called');
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        vm.title = 'Getty Report List View';
        vm.downloading = 0;
        vm.searching = 0;
        vm.download_id = "";
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            order_by:'',
            order_dir:'desc',
            page:1,
            limit:10
        };

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    //console.log(i, newValue[i], oldValue[i]);
                    vm.startSearch ++;

                    if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true ){
	                    //console.log(i, newValue[i], oldValue[i]);

	                    get_getty_list();
                    }else{
                        return "";
                    }
                }
            }
        });

        activate();

        function activate() {
            var promises = [
                get_getty_list()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_getty_list() {
            //vm.query.search = data;

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    return datacontext.get_getty_id_list(vm.query).then(function(httpResult) {
                        params.total(httpResult.data.count);
                        vm.results = httpResult.data.data;
                        vm.results_total = httpResult.data.count;
                        //console.log(vm.results);
                    });
                }
            });

        }

         $scope.download = function(id,title) {

            vm.downloading = 1;
            vm.download_id = id;
            log_success('Downloading');
            return datacontext.download_only_getty_image({"id":id,"title":title}).then(function (httpResult) {
                console.log(httpResult);
                log_success(httpResult.data.data);
                vm.downloading = 0;
                vm.download_id = "";
                get_getty_list();
                //get_getty_images();
                //$scope.$broadcast('refreshAuditLog', 'refresh');
            });
         };

    }
})();

(function () {
    'use strict';
    var controllerId = 'receivingCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location','NgTableParams', receivingCtrl]);
    function receivingCtrl(common, datacontext, $scope, $location, NgTableParams) {
        console.log('called');
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            search_by_id:0,
            order_by:'',
            order_dir:'desc',
            page:1,
            limit:30
        };

        activate();

        function activate() {
            var promises = [
                get_receiving()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }
        datacontext.get_location_types({warehouse_id:$scope.warehouse_id,isActive:1}).then(function (httpResult) {
            vm.location_types = httpResult.data.data;
        });
        function get_receiving() {
            return datacontext.get_receiving(vm.query).then(function(httpResult) {
                vm.results = httpResult.data.data;
            });
        }

        $scope.getreceiveList = function(search_location_type) {
          console.log(search_location_type);
          return datacontext.get_receiving({search_location_type:search_location_type}).then(function(httpResult) {
              vm.results = httpResult.data.data;
          });
        };


    }
})();
(function () {
    'use strict';
    var controllerId = 'stockCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location', '$modal', '$routeParams','NgTableParams', stockCtrl]);
    function stockCtrl(common, datacontext, $scope, $location, $modal, $routeParams, NgTableParams) {
        //console.log('called');
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.title = 'stock List View';
        vm.downloading = 0;
        vm.searching = 0;
        vm.download_id = "";
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            search_by_id:0,
            order_by:'',
            order_dir:'desc',
            page:1,
            limit:30
        };

        $scope.filterStockId = function(value) {
//        function filterGettyId(value) {
            //console.log('filter');
            //console.log(value);
            var list = vm.get_stock_id_list;
            //console.log(list);
            for (var i = 0; i < list.length; i++) {
                //console.log(list[i].getty_id);
                if(list[i].stock_id === value){
                   return false;
                }
                //console.log(item[key].getty_id);
            }
            return true;
        }
        activate();
        $scope.showpid = 0;
        function activate() {
            var promises = [
                get_stock_images()
                //,
                //get_stock_id_list()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        function get_stock_id_list(data) {
            return datacontext.get_stock_id_list({data:vm.stock_id_list}).then(function(httpResult) {
                vm.get_stock_id_list = httpResult.data.data;
            });
        }

        function get_stock_images(data,search_by_id) {

            vm.query.search = data;
            vm.query.search_by_id = search_by_id;

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_stock_images(vm.query).then(function (httpResult) {
                        console.log(httpResult.data);
                        // set new data
                        vm.results = httpResult.data.DATA;
                        vm.results_total = httpResult.data.COUNT;
                        vm.get_stock_id_list = httpResult.data.DATA1.data;
                        vm.LATEST_TITLE = httpResult.data.LATEST_TITLE;
                        vm.LATEST_YODA_PID = httpResult.data.LATEST_YODA_PID;
                        if(angular.isDefined(httpResult.data.COUNT)){
                            log_success(httpResult.data.COUNT+' Results Found');
                        }else{
                            log_error(httpResult.data.ERROR);
                        }
                        vm.searching = 0;
                        //return httpResult.data.DATA;
                    });
                }
            });
        }
        function get_stock_images_dwd(data,search_by_id) {

            vm.query.search = data;
            vm.query.search_by_id = search_by_id;

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_stock_images_dwd(vm.query).then(function (httpResult) {
                        console.log(httpResult.data);
                        // set new data
                        vm.results = httpResult.data.DATA;
                        vm.results_total = httpResult.data.COUNT;
                        if(angular.isDefined(httpResult.data.COUNT)){
                            log_success(httpResult.data.COUNT+' Results Found');
                        }else{
                            log_error(httpResult.data.ERROR);
                        }
                        vm.searching = 0;
                        return httpResult.data.DATA;
                    });
                }
            });
        }

        function get_stock_images_dwd_sold(data,search_by_id) {

            vm.query.search = data;
            vm.query.search_by_id = search_by_id;

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_stock_images_dwd_sold(vm.query).then(function (httpResult) {
                        console.log(httpResult.data);
                        // set new data
                        vm.results = httpResult.data.DATA;
                        vm.results_total = httpResult.data.COUNT;
                        if(angular.isDefined(httpResult.data.COUNT)){
                            log_success(httpResult.data.COUNT+' Results Found');
                        }else{
                            log_error(httpResult.data.ERROR);
                        }
                        vm.searching = 0;
                        return httpResult.data.DATA;
                    });
                }
            });
        }

        $scope.search = function(data,search_by_id) {
          console.log(data);
          console.log(search_by_id);
          if(angular.isDefined(search_by_id) && search_by_id === "get_dwd"){
            $scope.showpid = 1;
            get_stock_images_dwd();
          }else if(angular.isDefined(search_by_id) && search_by_id === "sold_items"){
            $scope.showpid = 2;
            get_stock_images_dwd_sold();
          }else if(angular.isDefined(search_by_id) && search_by_id == 1 && !angular.isNumber(vm.query.search) && vm.query.search.length !== 9){
              log_error('Invalid stock Id')
              return "";
          }else{
            vm.searching = 1;
            $scope.showpid = 0;
            get_stock_images(data,search_by_id);
          }


        };

        $scope.download_stock = function(id,title,presell) {
           console.log(id+','+title+','+presell);
           vm.downloading = 1;
           vm.download_id = id;
           log_success('Downloading');
           return datacontext.download_stock_image({"id":id,"title":title,"presell":presell}).then(function (httpResult) {
              console.log(httpResult.data);
              if(angular.isDefined(httpResult.data.DWDMESSAGE)){
                log_error(httpResult.data.DWDMESSAGE);
              }else{
                log_success('Product Created:' +httpResult.data.data);
              }

               vm.downloading = 0;
               //get_stock_id_list({data:vm.stock_id_list});
               $scope.showpid = 0;
               get_stock_images();
               //$scope.$broadcast('refreshAuditLog', 'refresh');
           });
        };
        $scope.download_stock_hires = function(id,title,presell,product_id) {
           console.log(id+','+title+','+presell +','+product_id);
           vm.downloading = 1;
           vm.download_id = id;
           log_success('Downloading');
           return datacontext.download_stock_image_hires({"id":id,"title":title,"presell":presell,"product_id":product_id}).then(function (httpResult) {
               console.log(httpResult.data);
              if(httpResult.data.DWD === 2){
                log_error('Image NOT downloaded:' +httpResult.data.INFO);
                vm.error_message = 'Image NOT downloaded:' +httpResult.data.INFO;
                var modalInstance = $modal.open({
                      scope:$scope,
                      template: "<div><b>{{vm.error_message}}</b><br></div><div style='float:right;'><button ng-click='cancel()'>I got it!</button></div>",
                      controller: function(){
                          $scope.cancel = function(){
                            modalInstance.dismiss('cancel');
                          };
                      }
                  });
              }else{
                log_success('Image downloaded:' +httpResult.data.INFO);
              }

               vm.downloading = 0;
               //get_stock_id_list({data:vm.stock_id_list});
               $scope.showpid = 0;
               //get_stock_images();
               //$scope.$broadcast('refreshAuditLog', 'refresh');
           });
        };




    }
})();
